import { MenuItemType } from '@components/menu';
import { QuoteType } from '@models/quotes';
import { QuoteActivityItemType } from '@pages/QuoteDetails/sidebarItems/summary/quoteActivity/QuoteActivityItem.constants';
import { Day, getDay, isThisMonth, isThisWeek, isToday, isYesterday } from 'date-fns';

export enum DateHeaderLabel {
  Today = 'Today',
  Yesterday = 'Yesterday',
  PastWeek = 'Past 7 Days',
  PastMonth = 'Past Month',
  Older = 'Older',
}

export enum Sorting {
  Newest = 'Newest',
  Oldest = 'Oldest',
}

export interface IQuoteActivity {
  quoteId: string;
  quoteType: QuoteType;
}

export interface IFilteringItem {
  type: MenuItemType;
  text: string;
  checked: boolean;
  activityItemType: QuoteActivityItemType;
  order: number;
}

export interface IFiltering {
  list: IFilteringItem[];
  anchorEl: (EventTarget & HTMLButtonElement) | null;
}

export interface ISorting {
  type: Sorting;
  anchorEl: (EventTarget & HTMLButtonElement) | null;
}

export const externalFilterInitialState: IFilteringItem[] = [
  {
    type: MenuItemType.Checkbox,
    text: 'Milestones',
    checked: true,
    activityItemType: QuoteActivityItemType.QuoteStatusChange,
    order: 2,
  },
  {
    type: MenuItemType.Checkbox,
    text: 'Messages',
    checked: true,
    activityItemType: QuoteActivityItemType.Message,
    order: 3,
  },
];

export const internalFilterInitialState: IFilteringItem[] = [
  ...externalFilterInitialState,
  {
    type: MenuItemType.Checkbox,
    text: 'Ratings',
    checked: true,
    activityItemType: QuoteActivityItemType.QuoteRating,
    order: 5,
  },
  {
    type: MenuItemType.Checkbox,
    text: 'Notes',
    checked: true,
    activityItemType: QuoteActivityItemType.Note,
    order: 4,
  },
  {
    type: MenuItemType.Checkbox,
    text: 'Documents',
    checked: true,
    activityItemType: QuoteActivityItemType.Document,
    order: 1,
  },
  {
    type: MenuItemType.Checkbox,
    text: 'Underwriting Activity',
    checked: true,
    activityItemType: QuoteActivityItemType.UnderwritingActivity,
    order: 6,
  },
]?.sort((a, b) => a.order - b.order);

export const getDateHeaderLabel = (date: Date): DateHeaderLabel => {
  if (isToday(date)) {
    return DateHeaderLabel.Today;
  }
  if (isYesterday(date)) {
    return DateHeaderLabel.Yesterday;
  }
  if (isThisWeek(date, { weekStartsOn: getDay(date) as Day })) {
    return DateHeaderLabel.PastWeek;
  }
  if (isThisMonth(date)) {
    return DateHeaderLabel.PastMonth;
  }
  return DateHeaderLabel.Older;
};
